export enum SEARCH_CATEGORIES {
  ACTS = 'acts',
  BANKS = 'banks'
}
